/**
 * @generated SignedSource<<141ab47fcb7a6f66b155c45e75c8f608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_similarLandingItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
  readonly " $fragmentType": "PdpRespContainer_similarLandingItems";
};
export type PdpRespContainer_similarLandingItems$key = {
  readonly " $data"?: PdpRespContainer_similarLandingItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_similarLandingItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_similarLandingItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems"
    }
  ],
  "type": "moreLikeThisItemConnection",
  "abstractKey": null
};

(node as any).hash = "0022f4d69cdd9fde6e1f625ad0226256";

export default node;
